import DayBox from './DayBox';

export default DayBox;
